/**
 * Global Typography System
 *
 * Mirrors the colors.ts pattern — update fonts in one place and they flow globally.
 * Based on strikeUp Brand Style Guide v1.0.
 *
 * Font roles:
 *  - preHeader : Geist Mono, 500, 14px, 1.40px letter-spacing, UPPERCASE
 *  - heading   : Geist, 400, 110% line-height, -3.12px letter-spacing
 *  - body      : Geist, 400, 16px, 150% line-height
 */

export const fontFamilies = {
  body: "'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  heading: "'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  mono: "'Geist Mono', 'Courier New', Courier, monospace",
};

export const typography = {
  preHeader: {
    fontFamily: fontFamilies.mono,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '15px',
    letterSpacing: '1.40px',
    textTransform: 'uppercase' as const,
  },
  heading: {
    fontFamily: fontFamilies.heading,
    fontWeight: 400,
    lineHeight: '110%',
    letterSpacing: '-0.05em', // approx -3.12px at typical heading sizes
  },
  body: {
    fontFamily: fontFamilies.body,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0',
  },
};

export type TypographyRole = keyof typeof typography;

export const getFont = (role: TypographyRole) => typography[role];
